import License from './license'

export default License